import React, { useState, useEffect, useRef } from "react";
import styles from "./SignUpDropDown.module.css";
import InputBox from "../InputBox";

const SignUpDropDown = ({
  data,
  value,
  showDropDown,
  onChange,
  placeholder,
  classes,
  isSearchable = true,
  scrollbar = true,
  type="",

  formatValue = (value) => {
    if (!value) return '';
    
    if (typeof value === 'object') {
      return value;
    }

    if (typeof value === 'string' && value.includes('_')) {
      return value
        .split('_')
        .map(word => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
        .join(' ');
    }
    if (value === value.toUpperCase()) {
      return value.charAt(0).toUpperCase() + value.slice(1).toLowerCase();
    }

    return value;
  }
}) => {
  const [options, setOptions] = useState([]);
  const [searched, setSearched] = useState("");
  const myRef = useRef(null);

  useEffect(() => {
    if (myRef && myRef.current) {
      myRef.current.focus();
    }
  }, [showDropDown]);

  useEffect(() => {
    setOptions(data || []);
  }, [data]);

  useEffect(() => {
    if (searched !== "") {
      const updatedList = (data || [])?.filter((item) => {
        if (!item) return false;
      if (type === "EditRole") {
        return item?.role_title.toLowerCase().includes(searched.toLowerCase());
      }
      const itemAsString = typeof item === 'string' ? item : '';
      const formattedItem = formatValue(item).toLowerCase();
      const searchTerm = searched.toLowerCase();
      return itemAsString.toLowerCase().includes(searchTerm) || formattedItem.includes(searchTerm);
     
    
    });
      setOptions([...updatedList]);
    } else {
      setOptions(data || []);
    }
  }, [searched, data]);

  const renderDisplayValue = (item) => {
    if (!item) return '';
    if (type === "EditRole") {
      return item.role_title;
    }
    return formatValue(item);
  };

  return (
    <>
      {showDropDown ? (
        <div
          style={scrollbar === false ? { overflow: "auto" } : {}}
          className={`${classes} ${styles.dropdownBox} ${styles[classes]}`}
        >
          {isSearchable ? (
            <div style={{ padding: "12px" }}>
              <InputBox
                placeholder={placeholder}
                value={searched}
                refValue={myRef}
                type="text"
                name="serached"
                onChange={(e) => setSearched(e.target.value)}
              />
            </div>
          ) : (
            ""
          )}
          {options && options.length > 0 ? (
            options.map((item, index) => {
              return (
                <div
                  key={index}
                  className={styles.optionText}
                  onClick={() => onChange(item)}
                >
                {renderDisplayValue(item)}
                </div>
              );
            })
          ) : (
            <div className={styles.noData}>No Results Found</div>
          )}
        </div>
      ) : (
        ""
      )}
    </>
  );
};

export default SignUpDropDown;
